var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BI',{attrs:{"id":1,"isHome":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }